import type { SxProps } from "@mui/material";

const breadcrumbsStyle: SxProps = {
  overflow: "hidden",
  fontSize: "0.875rem",
  color: "#344767",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",

  "& .MuiBreadcrumbs-ol": {
    flexWrap: "nowrap",
  },

  "& .breadcrumbs__divider": {
    px: 0.5,
  },

  "& a": {
    cursor: "pointer",
    textDecoration: "none",

    "&:hover": {
      textDecoration: "underline",
    },
  },
};

const separatorStyle: SxProps = {
  px: 0.5,
};

export { breadcrumbsStyle, separatorStyle };
